import Events from '../lib/events';
import ClassList from '../lib/classList.js';
import UrlHash from '../lib/urlHash';
import {showVote} from './vote';

export default class Rate {
  static params = {
    buttonSelector: '.js-rate-button',
    activeClassName: 'is-active'
  };

  static TYPES = {
    INCREASE: 'increase',
    DECREASE: 'decrease'
  };

  constructor($container) {
    this.$container = $container;
    this.$buttons = this.$container.querySelectorAll(Rate.params.buttonSelector);

    this.events = new Events(this.$container);

    this.bindEvents();
  }

  bindEvents() {
    this.events.bind(
      'click',
      Rate.params.buttonSelector,
      (event, $button) => {
        event.preventDefault();

        if ($button.disabled === false) {
          let params = Object.assign({}, this.$container.dataset, $button.dataset);

          Rate.disableButtons(this.$buttons);
          this.save($button, params);
        }
      },
      true
    );
  }

  save($button, params) {
    let data = {
      id: params.id,
      action: params.action,
      csrfmiddlewaretoken: params.csrf
    };
    let actionType = Rate.getButtonType($button);
    let $otherButtons;

    // change text
    if (actionType === Rate.TYPES.INCREASE) {
      Rate.increase($button);
      $otherButtons = Rate.resetOther(this.$buttons, $button);
    } else if (actionType === Rate.TYPES.DECREASE) {
      Rate.decrease($button);
    } else {
      throw new TypeError('Unexpected action type ' + actionType);
    }

    return fetch(params.url, {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: UrlHash.fromObject(data)
    })
      .then((rawResponse) => {
        if (rawResponse.ok) {
          return rawResponse.json();
        } else {
          throw new Error(rawResponse.statusText);
        }
      })
      .then((response) => {
        if (response && response.success) {
          Rate.enableButtons(this.$buttons);

          if (actionType === Rate.TYPES.INCREASE) {
            showVote(5000);
          }
        } else {
          throw new Error('Unexpected response type');
        }
      })
      .catch((error) => {
        Rate.enableButtons(this.$buttons);
        if (actionType === Rate.TYPES.INCREASE) {
          Rate.decrease($button);
          if ($otherButtons) {
            $otherButtons.forEach(($otherButton) => {
              Rate.increase($otherButton);
            });
          }
        } else if (actionType === Rate.TYPES.DECREASE) {
          Rate.increase($button);
          if ($otherButtons) {
            $otherButtons.forEach(($otherButton) => {
              Rate.decrease($otherButton);
            });
          }
        }

        console.error(error);
      });
  }

  static resetOther($buttons, $button) {
    return Array.prototype.filter
      .call($buttons, ($currentButton) => {
        let buttonClassList = new ClassList($currentButton.classList);
        return buttonClassList.has(Rate.params.activeClassName) && $currentButton !== $button;
      })
      .map(($activeButton) => {
        return Rate.decrease($activeButton);
      });
  }

  static enableButtons($buttons) {
    $buttons.forEach(($button) => {
      $button.disabled = false;
    });

    return $buttons;
  }

  static disableButtons($buttons) {
    $buttons.forEach(($button) => {
      $button.disabled = true;
    });

    return $buttons;
  }

  static increase($button) {
    let count = Rate.getCount($button);
    let buttonClassList = new ClassList($button.classList);
    buttonClassList.add(Rate.params.activeClassName);
    buttonClassList.applyTo($button);

    Rate.setCount($button, count + 1);

    return $button;
  }

  static decrease($button) {
    let count = Rate.getCount($button);
    let buttonClassList = new ClassList($button.classList);
    buttonClassList.remove(Rate.params.activeClassName);
    buttonClassList.applyTo($button);

    Rate.setCount($button, count - 1);

    return $button;
  }

  static getButtonType($button) {
    let buttonClassList = new ClassList($button.classList);

    return buttonClassList.has(Rate.params.activeClassName)
      ? Rate.TYPES.DECREASE
      : Rate.TYPES.INCREASE;
  }

  static getCount($button) {
    let textNode = $button.querySelector('span');
    return parseFloat((textNode.textContent.match(/[0-9.]+/) || [0])[0]) || 0;
  }

  static setCount($button, count) {
    let textNode = $button.querySelector('span');

    textNode.textContent = textNode.textContent.replace(/[0-9.]+/, Math.max(0, count).toString());

    return $button;
  }

  static initAll() {
    document.querySelectorAll('.js-rate').forEach(($container) => {
      new Rate($container);
    });
  }
}
